<template>
	<v-app>

		<!-- DEFAULT -->
		<Default />

  	</v-app>
</template>

<script>
import Default from '@/components/layouts/Default'

export default {
	name: 'App',
  	data: () => ({
    	layout: 'default'
	}),
	watch: {
		'$route.path': function() {
			window.scrollTo(0, 0);
		}
	},
	components: {
		Default
	}
}
</script>

<style>
	a {
		color: #616161 !important;
	}
	.v-btn {
		/* text-transform: none !important; */
		font-size: 12px !important;
	}
	/* .v-btn__content {
    	font-size: 11px !important;
	  } */
</style>


